import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { Box, Paper, Typography } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "60vh",
    px: 2,
  },
  paper: {
    maxWidth: 520,
    width: "100%",
    p: 4,
    textAlign: "center",
    borderRadius: 2,
  },
  icon: {
    width: 64,
    height: 64,
    mx: "auto",
    mb: 2.5,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(244, 67, 54, 0.1)",
    color: "error.main",
  },
  message: {
    color: "text.secondary",
  },
  helpText: {
    mt: 1,
    color: "text.secondary",
  },
};

const AccessDenied = ({
  title,
  message,
  helpText,
  page,
}) => {
  const intl = useIntl();

  const messageId = page
    ? "accessDenied.message"
    : "accessDenied.message.generic";

  const messageValues = page ? { page } : undefined;

  return (
    <Box sx={styles.container}>
      <Paper elevation={2} sx={styles.paper}>
        <Box sx={styles.icon}>
          <LockOutlinedIcon fontSize="large" />
        </Box>

        <Typography variant="h5" gutterBottom>
          {title ?? intl.formatMessage({ id: "accessDenied.title" })}
        </Typography>

        <Typography variant="body1" sx={styles.message}>
          {message ?? intl.formatMessage({ id: messageId }, messageValues)}
        </Typography>

        <Typography variant="body2" sx={styles.helpText}>
          {helpText ?? intl.formatMessage({ id: "accessDenied.helpText" })}
        </Typography>
      </Paper>
    </Box>
  );
};

AccessDenied.propTypes = {
  title: PropTypes.node,
  message: PropTypes.node,
  helpText: PropTypes.node,
  page: PropTypes.string,
};

export default AccessDenied;
